<template>
  <div>
    <h1>Catalogue des Références</h1>
    <b-row id="toptab">
      <b-col md="5">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
      </b-col>
      <b-col md="2" class="mb-0">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="addNewReference()"
        >Ajout d'une référence</b-button>
      </b-col>
    </b-row>
    <b-table
      id="my-table"
      ref="table"
      :bordered="bordered"
      :outlined="outlined"
      :busy.sync="isBusy"
      :items="getReferencesAsync"
      :fields="fields"
      :filter="filter"
      filter-debounce="400"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <!-- <b-spinner class="align-middle"></b-spinner> -->
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <template v-slot:cell(loops)="row">
        <b-badge class="clickBadge" variant="info" v-for="(loop, index) in row.item.loops" :key="index" @click="goToLoopList(row, loop)">{{loop}}</b-badge>
        <b-button size="sm" variant="success" @click="updateLogistic(row)" class="mr-2">
          <i class="fa fa-plus" aria-hidden="true"></i> Ajouter à une boucle
        </b-button>

        <!-- <b-button size="sm" variant="success" @click="selectRow(row)" v-b-modal.loopStatus>
          <i class="fa fa-edit" aria-hidden="true" ></i> Modifier ses boucles
        </b-button> -->
      </template>
      <template v-slot:cell(weight)="row">
        <p>{{row.item.weight.toFixed(3)}}</p>
      </template>
      <template v-slot:cell(code)="row">
        <p>{{chunk(row.item.code, 3)}}</p>
      </template>
      <template v-slot:cell(kanban_card)="row">
        <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
        <!-- <b-button
          size="sm"
          @click="showDetail(row)"
          class="mr-2"
        >{{ row.showDetail ? 'Cacher' : 'Afficher'}} Cartes</b-button> -->
        <br />
        <!-- <b-button
          size="sm"
          style="font-size:12px;margin-left:10px;"
          @click="goTo('/andon/'+row.item.code)"
          class="mr-2"
          variant="outline-primary"
        >Hippodrome</b-button> -->
      </template>
      <template v-slot:row-details="row">
        <!-- <b-button size="sm" @click="recomputeCards(row)" class="mr-2">Recalculer les cartes</b-button> -->
        <b-card>
          <b-table striped hover :items="detailsItems" :fields="detailsFields"></b-table>
          <b-button size="sm" @click="showDetail(row)">Cacher Cartes</b-button>
        </b-card>
      </template>
      <template v-slot:cell(seconds_since_last_scan)="row">
        <p>{{row.item.seconds_since_last_scan}} J</p>
      </template>
      <template v-slot:cell(update)="row">
        <div>
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <b-button
            size="sm"
            variant="primary"
            :disabled="needsToBeDisabled(row)"
            @click="moveToUpdateView(row)"
            class="mr-2"
          >
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>
      <template v-slot:cell(disable)="row">
        <div>
          <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
          <b-button
            size="sm"
            variant="danger"
            :disabled="needsToBeDisabled(row)"
            @click="disable(row)"
            class="mr-2"
          >
            <i class="fa fa-trash" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          v-model="currentPage"
        />
      </b-col>
    </b-row>


      <!-- <LoopStatusModal v-if="selectedCode" /> -->



  </div>
</template>
<script>
import server from '../../api/server.vue'
import referenceApi from '../../api/reference.vue'
import LoopStatusModal from '../supply/LoopStatusModal.vue'
import { mapGetters } from 'vuex'


export default {
  name: 'Kanbanreference',
  data() {
    return {
      currentPage: 1,
      totalRows: 0,
      isBusy: false,
      filter: null,
      actualCtx: '',
      perPage: 20,
      bordered: true,
      outlined: true,
      detailsFields: [
          { key: 'card_id', sortable: true },
          { key: 'card_index', sortable: true },
          // { key: 'removed', sortable: true },
          { key: 'seconds_since_last_scan', label: 'Jours depuis le dernier scan', sortable: true },
        ],
      fields: [
        { key: 'loops' },
        { key: 'code', label: 'Code', sortable: true },
        { key: 'designation', label: 'Designation', sortable: true },
        { key: 'weight', label: 'Poids', sortable: true },
        { key: 'emplacement', sortable: true },
        { key: 'rotation', sortable: true },
        // 'kanban_card',
        'update',
        'disable'
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedCode'])
  },
  methods: {
    goToLoopList(row, loop) {
      this.$store.commit('setSelectedCode', row.item.code)
      this.goTo('/' + loop)
    },
    selectRow(row) {
      this.$store.commit('setSelectedCode', row.item.code)
      this.$store.commit('updateKanbanForm', row.item)

    },
    moveToUpdateView(row) {
      this.goTo('/references/new/' + row.item.code)
    },
    updateLogistic(row) {
      this.$store.commit('setChangeOnlyLogistic', true)
      this.goTo('/references/new/' + row.item.code)
    },
    showDetail (row) {
      server.getKanbanCardByReference(row.item.code, row.item.loops[0]).then( response =>  {
        this.detailsItems = response.data
        this.totalDetailsRows = this.detailsItems.length
        if ( this.previousRowDetailed && row.item.code != this.previousRowDetailed.item.code)
        {
          this.previousRowDetailed.toggleDetails()
        }
        this.previousRowDetailed = row
        row.toggleDetails()
      //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
      })
    },
    addNewReference() {
      this.$store.commit('setSelectedCode', '')
      this.goTo('/references/new/')
    },
    sageDbEmplacementMismatch(row) {
      return row.item.andon !== ''
    },
    needsToBeDisabled(row) {
      return row.item.removed === 'Supprimé'
    },
    disable(row) {
      referenceApi.removeReference(row.item.code).then(result => {
        row.item.removed = 'Supprimé'
        row.item.loops = []
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    makeToast(result, append = false) {
      let toast = this.$toasted.success(result + ' mis à jour', {
        theme: 'bubble',
        position: 'top-right',
        duration: 5000
      })
    },
    forceRefresh() {
      this.getReferencesAsync(this.actualCtx).then(result => {
        this.$refs.table.refresh()
      })
    },
    getReferencesAsync(ctx) {
      return referenceApi.getFilteredReferences(ctx).then(response => {
        var data = response.data.references
        var formatedResult = []

        this.totalRows = response.data.total_references
        for (var i = 0; i < data.length; i++) {
          if (data[i]['removed']) {
            data[i]['removed'] = 'Supprimé'
            data[i]['isActive'] = false
          } else {
            data[i]['removed'] = ''
          }
          data[i]['reference']['code'] = this.chunk(data[i]['reference']['code'], 3)
          data[i]['emplacement'] =
            data[i]['zone'] +
            data[i]['pos_y'] +
            ('0' + data[i]['pos_x']).slice(-2) +
            data[i]['pos_z']
          formatedResult.push(data[i])
        }
        this.actualCtx = ctx
        return formatedResult
      })
    }
  },
  mounted: function() {},
  components: { LoopStatusModal }
}
</script>


<style type="text/css" scoped>
.clickBadge:hover {
  cursor: pointer;
}
.btn {
  margin-left: 0px !important;
  margin-top: 2px !important;
}
#toptab {
  margin-bottom: 5%;
  margin-top: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/supply/ListReferences.vue